import React from "react";
import Swap from "./Swap";
import Balance from "./Balance";
import Liquidity from "./Liquidity";

function Content({
  view,
  tokenABalance,
  tokenBBalance,
  poolABalance,
  poolBBalance,
  pendingTransactions,
  changePendingTransactions,
  account,
  newAccount,
}: {
  view: string;
  tokenABalance: number;
  tokenBBalance: number;
  poolABalance: number;
  poolBBalance: number;
  pendingTransactions: Object;
  changePendingTransactions: Function;
  account: string;
  newAccount: Function;
}) {
  return view === "swap" ? (
    <Swap
      pendingTransactions={pendingTransactions}
      changePendingTransactions={changePendingTransactions}
      account={account}
      poolABalance={poolABalance}
      poolBBalance={poolBBalance}
    />
  ) : view === "balance" ? (
    <Balance
      account={account}
      newAccount={newAccount}
      tokenABalance={tokenABalance}
      tokenBBalance={tokenBBalance}
      pendingTransactions={pendingTransactions}
      changePendingTransactions={changePendingTransactions}
    />
  ) : view === "liquidity" ? (
    <Liquidity
      poolABalance={poolABalance}
      poolBBalance={poolBBalance}
      pendingTransactions={pendingTransactions}
      changePendingTransactions={changePendingTransactions}
    />
  ) : null;
}

export default Content;
